import "./FirmStory.module.css";
import Header from "@/reusable_sections/Header";
import OurCommitmentToYourLegacy from "./sections/OurCommitmentToYourLegacy";
import TheLegalTeam from "./sections/TheLegalTeam";
import Footer from "@/reusable_sections/Footer";
export default function FirmStoryPage() {
  return <div>
      <Header />
      <OurCommitmentToYourLegacy />
      <TheLegalTeam />
      <Footer />
    </div>;
}